import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_ENDPOINTS } from '../utils/api.constants';
import { TenantSummary } from '../models/tenant.model';
import { CreateTenantServiceRequest, TenantServiceAssignment, UpdateTenantServiceRequest } from '../models/tenant-service.model';

@Injectable({
  providedIn: 'root'
})
export class TenantsService {

  constructor(private http: HttpClient) { }

  getTenants(): Observable<TenantSummary[]> {
    return this.http.get<TenantSummary[]>(API_ENDPOINTS.TENANTS.LIST);
  }

  getTenantServices(tenantUid: string): Observable<TenantServiceAssignment[]> {
    const params = new HttpParams().set('tenant_uid', tenantUid);
    return this.http.get<TenantServiceAssignment[]>(API_ENDPOINTS.TENANT_SERVICES.LIST, { params });
  }

  createTenantService(payload: CreateTenantServiceRequest): Observable<TenantServiceAssignment> {
    return this.http.post<TenantServiceAssignment>(API_ENDPOINTS.TENANT_SERVICES.LIST, payload);
  }

  updateTenantService(id: number, payload: UpdateTenantServiceRequest): Observable<TenantServiceAssignment> {
    return this.http.patch<TenantServiceAssignment>(API_ENDPOINTS.TENANT_SERVICES.DETAIL(id), payload);
  }

  deleteTenantService(id: number): Observable<void> {
    return this.http.delete<void>(API_ENDPOINTS.TENANT_SERVICES.DETAIL(id));
  }
}
